<div class="route-details">
    <div class="route-details__address">
        <span class="route-details__address__label">{{'start'|translate}}:</span>
        <span class="route-details__address__value">
            <tk-vehicle-location *ngIf="startLocationRoute" [location]="startLocationRoute.D?.S"></tk-vehicle-location>
            {{ startLocationRoute?.En | date: 'HH:mm' }}
        </span>
    </div>
    <div class="route-details__address">
        <span class="route-details__address__label">{{'end'|translate}}:</span>
        <span class="route-details__address__value">
            <ng-container *ngIf="endLocationRoute?.T === 3; else noDriving">
                {{'vehicle-details-routes-tab.driving'|translate}}...
            </ng-container>
            <ng-template #noDriving>
                <tk-vehicle-location *ngIf="endLocationRoute" [location]="endLocationRoute.D?.S"></tk-vehicle-location>
                {{ (endLocationRoute?.En || endLocationRoute?.St) | date: 'HH:mm' }}
            </ng-template>
        </span>
    </div>

    <div *ngIf="isLoading" class="route-details__loading-summary">
        <p-skeleton height="48px"></p-skeleton>
    </div>

    <div *ngIf="!isLoading" class="route-details__summary">
        <div class="route-details__summary__item">
            <span class="route-details__summary__item__value">
                {{ _data.distance | distance }}
            </span>
            <span class="route-details__summary__item__label" [title]="'distance'|translate">{{'distance'|translate}}</span>
        </div>
        <div class="route-details__summary__item">
            <span class="route-details__summary__item__value">
                <tk-time [minutes]="_data.time"></tk-time>
            </span>
            <span class="route-details__summary__item__label" [title]="'driveTime'|translate">{{'driveTime'|translate}}</span>
        </div>
        <div class="route-details__summary__item">
            <span class="route-details__summary__item__value">
                {{_data.fuel | fuel}} L
            </span>
            <span class="route-details__summary__item__label" [title]="'fuelConsumed'|translate">{{'fuelConsumed'|translate}}</span>
        </div>
        <div class="route-details__summary__item">
            <span class="route-details__summary__item__value">
                {{_data.fuelPer100 | fuel}} L/100km
            </span>
            <span class="route-details__summary__item__label" [title]="'fuelConsumption'|translate">{{'fuelConsumption'|translate}}</span>
        </div>
    </div>
</div>
